export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 8c-1.1 0-2-.9-2-2s.9-2 2-2c-1.1 0-2-.9-2-2s.9-2 2-2v2c1.1 0 2 .9 2 2s-.9 2-2 2v2zm-4-5a1 1 0 11-2 0 1 1 0 012 0zM8 6l10 10-18 8L8 6zm2.66 11.07l-3.73-3.73-2.99 6.72 6.72-2.99zm1.96-.86l1.91-.85-5.88-5.89-.85 1.91 4.82 4.83zM21 16a1 1 0 100-2 1 1 0 000 2zM17.294 5.292l2.998-2.998 1.414 1.414-2.998 2.998-1.414-1.414zM22 10c0-1.1-.9-2-2-2s-2 .9-2 2h-2c0 1.1.9 2 2 2s2-.9 2-2c0 1.1.9 2 2 2s2-.9 2-2h-2z\" fill=\"#ff00cb\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};